import React from 'react'
import styled from 'styled-components'
import {BodyText} from './text.js'
import Link from './link.js'
import theme from './theme.js'

const UnstyledSubItem = ({
  className,
  item
}) => {
  const props = {
    className 
  }

  const title = item.title

  return (
    <div {...props}>
      <Link {...item}>
        <Title>{title}</Title>
      </Link>
    </div>
  )
}

const SubItem = styled(UnstyledSubItem)`

`

const Title = styled(BodyText)`
  font-size: ${theme.font.size.p2};
`

export default SubItem